import styled from 'styled-components';
import {ButtonBase} from '../../../CommonStyleUtils/dwebCommon.styles';

/***Sign up banner container style */

export const SignUpBannerContainer = styled.div(
  props => `
  flex-direction: row;
  justify-content: space-between;
  display: flex;
  flex-wrap: wrap;
  align-items:center;
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  background-color: ${props.theme.colors.goBrandBlue.medium};
  padding:${props.theme.spacing.xlarge};
  margin-bottom:${props.theme.spacing.base};
`,
);

export const SignUpTextWrap = styled.div(
  props => `

  font-size:${props.theme.font.custom(16)};
  font-family: ${props.theme.font.fontFamily};
  color:${props.theme.colors.goBrandBlue.base};
  font-weight:bold;
  margin-left:${props.theme.spacing.xlarge}
`,
);

export const SignUpBannerLeftWrap = styled.div(
  props => `

  display:flex;
  align-items:center;
  // width: 100%;
`,
);

export const SignUpButtonWrap = styled(ButtonBase)(
  props => `
  padding: ${props.theme.spacing.base} ${props.theme.spacing.large};
  background-color: ${props.theme.colors.goWhite.base};
  color:${props.theme.colors.goBrandBlue.base};
  border-radius: ${props.theme.misc.borderRadius.base};
  justify-content: space-around;
  font-size:${props.theme.font.custom(14)};
  text-transform: capitalize;
`,
);
